import { useState, useEffect, Fragment } from "react";
import { useQuery } from "@tanstack/react-query";

// styled components
import { KanbanContainer, KanbanBoard, KanbanTrack, KanbanTrackHeader, KanbanTrackHeaderTitle, KanbanTrackHeaderInfo, KanbanTrackHeaderActions, KanbanDot, KanbanScrollable, NoTickets } from "./Common"

// mui
import { useTheme, Button, Badge } from "@mui/material";

import { BasicFlex } from "../../../../utils/Common";

// mui icons
import AddIcon from '@mui/icons-material/AddRounded';


// zustand store
import useRepairDashboardStore from "../../../../store/repair_dashboard";

// api services
import { getServiceCategories } from "../../../Services/apiService";

import { getStationView } from "../../apiService";

// Kanban Ticket
import KanbanTicket from "../KanbanTicket";

// drawer
import SideDrawer from "../SideDrawer";

const InHouseDashboard = ({ tickets = [], setTicket, setOpen }) => {

  const [sideBar, setSideBar] = useState({
      open: false,
      category: ""
    });

  const handleClose = () => {
    setSideBar({ open: false, category: "" });
  }

  const handleOpen = (category) => {
    setSideBar({ open: true, category });
  }

  const theme = useTheme();

  const sortedCategories = useRepairDashboardStore((state) => state.sortedCategories);
  const setSortedCategories = useRepairDashboardStore((state) => state.setSortedCategories);


  const { data: categories } = useQuery({
    queryKey: ['services', 'service_categories'],
    queryFn: () => getServiceCategories('repair'),
    staleTime: 30 * 60 * 1000 // 30 minutes
  })

  const { data: repairView } = useQuery({
    queryKey: ['settings', 'repairs', 'in_house_view'],
    queryFn: () => getStationView('in_house_view'),
    staleTime: 30 * 60 * 1000 // 30 minutes
  })

  // set up stations
  // comit
  useEffect(() => {
    if (repairView?.data?.length) {
      let sorted = repairView?.data.map(st => {
        if (st.name === "Repair Queue") {
          st.filter = (sts) => {return sts.filter((st) => st.status === "scheduled" || st.task_status === "scheduled")};
        }
        if (st.name === "Repair Done") {
          st.filter = (sts) => {return sts.filter((st) => st.status === "in_progress" && st.task_status === "completed")};
        }
        return st;
      })
      setSortedCategories(repairView?.data);
    } else {
      let defaultCategories = [
        { id: 1, name: "Repair Queue", active: true, filter: (sts) => {return sts.filter((st) => st.status === "scheduled" || st.task_status === "scheduled")}, noReception: true }
      ];

      if (categories?.length) {
        defaultCategories = defaultCategories.concat(categories.map((st, i) => ({ id: st.name, name: st.name, active: true, color: st.label_color })));
      }

      defaultCategories.push({
        id: 80,
        color: theme.palette.success.light,
        name: "Repair Done",
        active: true,
        filter: (sts) => {return sts.filter((st) => st.status === "in_progress" && st.task_status === "completed")},
        noReception: true
      })

      // defaultCategories.push({
      //   id: 82,
      //   color: theme.palette.warning.light,
      //   name: "Review",
      //   active: true,
      //   // filter: (sts) => {return sts.filter((st) => st.status === "in_progress" && st.task_status === "completed")},
      //   noReception: true
      // })
      setSortedCategories(defaultCategories);
    }
  }, [categories, repairView?.data]);

  return (
    <Fragment>
      <KanbanContainer>
        <KanbanBoard>
          {sortedCategories.filter((category) => category.active).map((category) => {
            let activeStatuses = ["accepted", "in_progress", "paused"];
            let filteredTickets = category && category.filter ? category.filter(tickets) : tickets?.filter((ticket) => ticket.category === category.name && activeStatuses.includes(ticket.status) && activeStatuses.includes(ticket.task_status));
            return (
            <KanbanTrack key={category.id}>
              <KanbanTrackHeader $color={category.paletteColor || category.color}>
                <KanbanTrackHeaderInfo justify="flex-start">
                  {/* <KanbanDot $color={category.color} /> */}
                  <KanbanTrackHeaderTitle>{category.name}</KanbanTrackHeaderTitle>
                  <Badge badgeContent={filteredTickets.length} showZero={false} slotProps={{ badge: { sx: { bgcolor: "black", color: "white !important" } } }} />
                </KanbanTrackHeaderInfo>
                <KanbanTrackHeaderActions>
                  {/* { !category.noReception ? <Button size="small" sx={{p: 0, minWidth: "unset"}} color="text" onClick={() => handleOpen(category?.name)}><AddIcon  /></Button> : null } */}
                </KanbanTrackHeaderActions>
              </KanbanTrackHeader>
              <KanbanScrollable $static={category.noReception}>
                {filteredTickets.length ? <BasicFlex dir="column" width="100%" gap="1rem">
                  {filteredTickets.map((ticket) => (
                    <KanbanTicket key={ticket.repair_ticket_id} ticket={ticket} setTicket={setTicket} setOpen={setOpen} />
                  ))}
                </BasicFlex> : <NoTickets />}
              </KanbanScrollable>
            </KanbanTrack>
          )})}
        </KanbanBoard>
      </KanbanContainer>
      <SideDrawer sideBar={sideBar} handleClose={handleClose} />
    </Fragment>
  )
};

export default InHouseDashboard;